import { tutorialAssets } from "assets/cdn";
import { useImagePath } from "hooks/useImagePath";
import { Grid, useMediaQuery } from "@mui/material";
import Button from "components/Buttons/ThemeButton";
import useCalculateScale from "components/PopUpManager/hooks/useCalculateScale";
import { debounce } from "lodash";
import { useEffect, useState } from "react";
import { Arrow, Background2, Text, Tiki2 } from "../../styles";

interface Slide2Props {
	onNext: () => void;
	onSkip: () => void;
	totalSlidesNumber: number;
}

export const Slide2 = ({ onNext, onSkip, totalSlidesNumber }: Slide2Props) => {
	const { getImage } = useImagePath("cdn");
	const background = getImage(tutorialAssets.background);
	const arrowUp = getImage(tutorialAssets.greenArrow);
	const tiki = getImage(tutorialAssets.char2);
	const isExtraSmall = useMediaQuery("(max-width: 380px)");
	const isPortrait = useMediaQuery("(orientation: portrait)");
	const scale = useCalculateScale(
		isPortrait ? 380 : 200,
		isPortrait ? 200 : 500
	);

	const [shine, setShine] = useState<HTMLElement | null>();
	const [subMenu, setSubMenu] = useState<HTMLElement | null>();
	const [tutorialPosition, setTutorialPosition] = useState<{
		top: number;
		left: number | string;
	}>({
		top: 370,
		left: isExtraSmall ? "-50%" : "-190px"
	});
	const [isFirstScroll, setIsFirstScroll] = useState<boolean>(true);

	const waitForScroll = async () => {
		await new Promise((resolve) => {
			const onScrollEnd = () => {
				window.removeEventListener("scrollend", onScrollEnd);
				resolve({});
			};
			window.addEventListener("scrollend", onScrollEnd);
			setTimeout(() => {
				window.removeEventListener("scrollend", onScrollEnd);
				resolve({});
			}, 500);
		});
	};

	const scrollAndHighlight = async () => {
		const sectionTitle = document.getElementById("Wilds");
		if (subMenu && sectionTitle) {
			sectionTitle.scrollIntoView({
				behavior: isFirstScroll ? "smooth" : "instant",
				block: window.innerHeight < 500 ? "start" : "center"
			});
			await waitForScroll();
			setIsFirstScroll(false);
			// set tutorial postition
			const tutorialPos = subMenu.getBoundingClientRect();
			const centerY = tutorialPos.top + tutorialPos.height + 10;
			setTutorialPosition({
				top: centerY,
				left: isExtraSmall ? "-50%" : "-190px"
			});

			//adjust wild shine position
			const wildButton = document.getElementById("expand-button-wilds");
			const wildButtonPos = wildButton?.getBoundingClientRect();
			if (wildButtonPos && shine) {
				const centerButtonY = wildButtonPos.top + wildButtonPos.height / 2;
				const centerButtonX = wildButtonPos.left + wildButtonPos.width / 2;
				shine.style.position = "fixed";
				shine.style.top = `${centerButtonY}px`;
				shine.style.left = `${centerButtonX}px`;
			}
		}
	};

	useEffect(() => {
		const subMenu = document.getElementById("sub-menu");
		setSubMenu(subMenu);
		subMenu?.setAttribute("style", "z-index: 99999");

		const shine = document.getElementById("sub-menu-shine-effect");
		setShine(shine);
		shine?.classList.add("animate");

		return () => {
			subMenu?.setAttribute("style", "z-index: 2");
			shine?.classList.remove("animate");
		};
	}, []);

	const debouncedHandleScroll = debounce(scrollAndHighlight, 100);

	useEffect(() => {
		scrollAndHighlight();
		window.addEventListener("scroll", debouncedHandleScroll);

		return () => {
			window.removeEventListener("scroll", debouncedHandleScroll);
		};
	}, [
		window.innerWidth,
		window.innerHeight,
		subMenu,
		isExtraSmall,
		isPortrait
	]);

	return (
		<>
			<Grid
				px={3}
				container
				maxWidth={380}
				position="fixed"
				left={tutorialPosition.left}
				top={tutorialPosition.top * scale + (scale < 1 ? 10 : 0)}
				sx={{ transform: `translateX(50vw) scale(${scale})` }}
			>
				<Grid item xs={12} display="flex" justifyContent="center">
					<Arrow src={arrowUp} alt="Arrow up" width={46} />
				</Grid>

				<Grid item xs={12} display="flex" justifyContent="right">
					<Text
						color="#fff"
						fontFamily="Baloo"
						fontSize="16px"
						lineHeight="17px"
					>
						2/{totalSlidesNumber}
					</Text>
				</Grid>

				<Grid item xs={12}>
					<Background2 $backgroundImage={background}>
						<Grid container mb={2}>
							<Grid item xs={2.5}>
								<Tiki2 src={tiki} alt="Tiki" bottom="12px" />
							</Grid>
							<Grid item xs={9.5} mb={1}>
								<Text
									color="#462C12"
									fontFamily="Inter"
									fontSize="16px"
									fontWeight={700}
									lineHeight="17px"
								>
									Use the top menu to explore
									<br /> Wilds, Volcanos, Coins and
									<br /> Boosters.
								</Text>
								<Text
									color="#462C12"
									fontFamily="Inter"
									fontSize="12px"
									lineHeight="15px"
								>
									Quickly browse the best offers.
								</Text>
							</Grid>
						</Grid>
						<Button className="next" onClick={onNext}>
							Next
						</Button>
						<Button className="skip" variant="text" onClick={onSkip}>
							Skip
						</Button>
					</Background2>
				</Grid>
			</Grid>
		</>
	);
};
